import { render, staticRenderFns } from "./app-detail-point-modal.vue?vue&type=template&id=5526eb0e&scoped=true";
import script from "./app-detail-point-modal.vue?vue&type=script&lang=js";
export * from "./app-detail-point-modal.vue?vue&type=script&lang=js";
import style0 from "./app-detail-point-modal.vue?vue&type=style&index=0&id=5526eb0e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5526eb0e", null);
export default component.exports;